function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ScriptingKeyTemplate = require('./scripting.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var _require = require('../../contracts'),
  listContracts = _require.listContracts,
  getContractScriptJson = _require.getContractScriptJson,
  getDefaultContractId = _require.getDefaultContractId;
var ScriptingKey = /*#__PURE__*/function () {
  function ScriptingKey(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, ScriptingKey);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod);
    this.callback = null;
    this.onReturnToDefault = null;
    this.contracts = listContracts();
    this.selected_contract_id = getDefaultContractId();
    this.custom_draft = getContractScriptJson(getDefaultContractId());
    this.script_text = this.custom_draft;
  }
  return _createClass(ScriptingKey, [{
    key: "render",
    value: function render() {
      var _this = this;
      this.overlay.show(ScriptingKeyTemplate(this.app, this.mod, {
        contracts: this.contracts,
        selected_contract_id: this.selected_contract_id,
        script_text: this.script_text
      }));
      setTimeout(function () {
        return _this.attachEvents();
      }, 25);
    }
  }, {
    key: "textarea",
    value: function textarea() {
      return document.querySelector('.vault-scripting-overlay .create-nft-script-textarea');
    }
  }, {
    key: "typeSelect",
    value: function typeSelect() {
      return document.getElementById('vault-script-type');
    }
  }, {
    key: "readEditor",
    value: function readEditor() {
      var el = this.textarea();
      return el ? el.value : this.script_text;
    }
  }, {
    key: "writeEditor",
    value: function writeEditor(text) {
      this.script_text = text;
      var el = this.textarea();
      if (el) {
        el.value = text;
      }
    }
  }, {
    key: "applyContractSelection",
    value: function applyContractSelection(next_id) {
      var current = this.readEditor();

      // Leaving Custom: remember the user's draft so switching back restores it.
      if (this.selected_contract_id === 'custom') {
        this.custom_draft = current;
      }
      this.selected_contract_id = next_id || getDefaultContractId();
      if (this.selected_contract_id === 'custom') {
        this.writeEditor(this.custom_draft || getContractScriptJson('custom'));
        return;
      }
      var build_opts = {};
      if (this.selected_contract_id === 'rental') {
        var _this$app, _this$mod;
        // Same source as Vault mintNFT recipient: app.wallet.publicKey
        var creator_publickey = ((_this$app = this.app) === null || _this$app === void 0 || (_this$app = _this$app.wallet) === null || _this$app === void 0 ? void 0 : _this$app.publicKey) || ((_this$mod = this.mod) === null || _this$mod === void 0 ? void 0 : _this$mod.publicKey);
        if (creator_publickey) {
          build_opts.creator_publickey = creator_publickey;
        }
      }
      var template = getContractScriptJson(this.selected_contract_id, true, build_opts);
      if (template) {
        this.writeEditor(template);
      }
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this2 = this;
      try {
        var type_select = this.typeSelect();
        if (type_select) {
          type_select.onchange = function (e) {
            _this2.applyContractSelection(e.target.value);
          };
        }
        var returnLink = document.querySelector('.vault-scripting-overlay [data-action="use-default-key"]');
        if (returnLink) {
          returnLink.onclick = function (e) {
            e.preventDefault();
            _this2.overlay.hide();
            if (typeof _this2.onReturnToDefault === 'function') {
              _this2.onReturnToDefault();
            }
          };
        }
        document.getElementById('mint_scripting_key_btn').onclick = function (e) {
          var _this2$app$core;
          if (!((_this2$app$core = _this2.app.core) !== null && _this2$app$core !== void 0 && (_this2$app$core = _this2$app$core.scripting) !== null && _this2$app$core !== void 0 && _this2$app$core.hash) || _this2.callback == null) {
            salert('Core scripting is not available - cannot calculate access_hash locally...');
            return;
          }
          var scriptjson = _this2.readEditor();
          var nft_type = _this2.selected_contract_id === 'rental' ? 'vault-nft-rental' : 'vault-nft-key';

          // Rental: re-bind creator pubkey so no CREATOR_PUBLICKEY_PLACEHOLDER remains.
          if (_this2.selected_contract_id === 'rental') {
            var _this2$app, _this2$mod;
            var creator_publickey = ((_this2$app = _this2.app) === null || _this2$app === void 0 || (_this2$app = _this2$app.wallet) === null || _this2$app === void 0 ? void 0 : _this2$app.publicKey) || ((_this2$mod = _this2.mod) === null || _this2$mod === void 0 ? void 0 : _this2$mod.publicKey);
            if (!creator_publickey) {
              salert('Wallet public key unavailable - cannot create rental contract...');
              return;
            }
            scriptjson = getContractScriptJson('rental', true, {
              creator_publickey: creator_publickey
            });
            _this2.writeEditor(scriptjson);
          }
          if (scriptjson.includes('CREATOR_PUBLICKEY_PLACEHOLDER')) {
            salert('Creator public key was not substituted into the rental contract...');
            return;
          }
          var access_hash = _this2.app.core.scripting.hash(scriptjson);
          _this2.callback({
            access_hash: access_hash,
            access_script: scriptjson,
            contract_id: _this2.selected_contract_id,
            nft_type: nft_type
          });
          _this2.overlay.remove();
        };
      } catch (err) {}
    }
  }]);
}();
module.exports = ScriptingKey;